import React, { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import { api } from "../lib/api";

const Stat = ({ label, value, id }) => (
  <div className="rounded-xl bg-[#F3F8F5] border border-emerald-100 px-4 py-2.5">
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
    <div data-testid={`cards-stat-${id}`} className="text-xl font-bold text-[#14532D]">{value}</div>
  </div>
);

export default function AdminAnswerCards() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/answer-cards").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  const t = d.totals;
  return (
    <section data-testid="admin-answer-cards" className="mt-6 rounded-2xl bg-white border border-emerald-100 p-4 space-y-4">
      <div className="flex items-center gap-2 font-display font-bold text-[#092C15]"><BarChart3 size={18} /> Answer Cards</div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        <Stat id="cards" label="Cards made" value={t.cards} /><Stat id="saves" label="Saved" value={t.saves} />
        <Stat id="shares" label="Shared / texted" value={t.shares} /><Stat id="copies" label="Copied" value={t.copies} />
        <Stat id="paid" label="Paid cards" value={t.paid || 0} />
      </div>
      {d.by_specialist.length > 0 && (
        <div className="flex flex-wrap gap-2 text-xs">
          {d.by_specialist.map((s) => <span key={s.id} className="rounded-full bg-slate-100 px-3 py-1">{s.name}: {s.cards} cards · {s.saves} saved · {s.shares} shared</span>)}
        </div>
      )}
      <div className="divide-y divide-slate-100 text-sm">
        {d.recent.map((r) => (
          <div key={r.id} data-testid={`answer-card-row-${r.id}`} className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1">
            <span className="font-medium text-slate-800 flex-1 min-w-[200px]">{r.title || "Untitled"}</span>
            <span className="text-xs text-slate-500">{r.speaker}{r.paid ? " · paid" : ""}{r.chat ? ` · ${r.chat}` : ""}</span>
            <span className="text-xs text-slate-500">{r.saves} saved · {r.shares} shared · {r.copies} copied</span>
            <span className="text-xs text-slate-400">{(r.created_at || "").slice(0, 10)}</span>
          </div>
        ))}
        {!d.recent.length && <p className="text-sm text-slate-500 py-2">No answer cards yet.</p>}
      </div>
    </section>
  );
}
